export const base = '/promo-offers';
